import axios from '../../shared/axios';

export function token(data) {
    return axios.post(
        Jobtoolz.api.url + '/content/v1/calendars/token',
        data
    ).then(response => response.data);
}
